var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box } from '@mui/material';
import * as Preact from 'preact';
import * as Image from './A_Image';
export var Component = function (p) {
    return (Preact.h(Box, { position: "relative", onClick: p.onClick, sx: __assign({ display: 'flex', borderRadius: '4px', overflow: 'hidden', backgroundColor: 'white !important', cursor: 'pointer' }, p.sx) },
        Preact.h(Image.Component, { imageSrc: p.imageSrc, sx: { height: '1px', padding: '50% 0' } })));
};
Component.displayName = 'ProductImageContainer';
